import { Button, Menu, MenuItem } from "@blueprintjs/core";
import { Popover2 } from "@blueprintjs/popover2";
import React from "react";
import styled from "styled-components";
import { useCommonHooks, useLanguages } from "../hooks";

const Container = styled.div``;

export interface LanguageSelectorProps {}

export const LanguageSelector: React.FC<LanguageSelectorProps> = () => {
  const { languages, changeLanguage, currentLanguage } = useLanguages();
  const { tUnsafe } = useCommonHooks();

  if (!currentLanguage) return null;

  return (
    <Container>
      <Popover2
        content={
          <Menu>
            {languages?.map((lg) => (
              <MenuItem
                key={lg.code}
                text={tUnsafe("Language_" + lg.code.toUpperCase())}
                onClick={() => changeLanguage(lg.code)}
              />
            ))}
          </Menu>
        }
        position={"bottom-right"}
        minimal
      >
        <Button
          rightIcon={"caret-down"}
          icon={"flag"}
          text={tUnsafe("Language_" + currentLanguage?.code.toUpperCase())}
          large
          minimal
        />
      </Popover2>
    </Container>
  );
};
